// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/announcement_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Announcement, AnnouncementSummary } from "./announcement_model_pb";
import { file_bffuser_v1_announcement_model } from "./announcement_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/announcement_service.proto.
 */
export const file_bffuser_v1_announcement_service: GenFile = /*@__PURE__*/
  fileDesc("CiViZmZ1c2VyL3YxL2Fubm91bmNlbWVudF9zZXJ2aWNlLnByb3RvEgpiZmZ1c2VyLnYxIhoKGExpc3RBbm5vdW5jZW1lbnRzUmVxdWVzdCJTChlMaXN0QW5ub3VuY2VtZW50c1Jlc3BvbnNlEjYKDWFubm91bmNlbWVudHMYASADKAsyHy5iZmZ1c2VyLnYxLkFubm91bmNlbWVudFN1bW1hcnkiTwoWR2V0QW5ub3VuY2VtZW50UmVxdWVzdBI1Cg9hbm5vdW5jZW1lbnRfaWQYASABKAlCHLpIGXIXEAEYQDIRXltBLVphLXowLTkuXy1dKyQiSQoXR2V0QW5ub3VuY2VtZW50UmVzcG9uc2USLgoMYW5ub3VuY2VtZW50GAEgASgLMhguYmZmdXNlci52MS5Bbm5vdW5jZW1lbnQy0wEKE0Fubm91bmNlbWVudFNlcnZpY2USYAoRTGlzdEFubm91bmNlbWVudHMSJC5iZmZ1c2VyLnYxLkxpc3RBbm5vdW5jZW1lbnRzUmVxdWVzdBolLmJmZnVzZXIudjEuTGlzdEFubm91bmNlbWVudHNSZXNwb25zZRJaCg9HZXRBbm5vdW5jZW1lbnQSIi5iZmZ1c2VyLnYxLkdldEFubm91bmNlbWVudFJlcXVlc3QaIy5iZmZ1c2VyLnYxLkdldEFubm91bmNlbWVudFJlc3BvbnNlQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_bffuser_v1_announcement_model, file_buf_validate_validate]);

/**
 * @generated from message bffuser.v1.ListAnnouncementsRequest
 */
export type ListAnnouncementsRequest = Message<"bffuser.v1.ListAnnouncementsRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListAnnouncementsRequest.
 * Use `create(ListAnnouncementsRequestSchema)` to create a new message.
 */
export const ListAnnouncementsRequestSchema: GenMessage<ListAnnouncementsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_announcement_service, 0);

/**
 * @generated from message bffuser.v1.ListAnnouncementsResponse
 */
export type ListAnnouncementsResponse = Message<"bffuser.v1.ListAnnouncementsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.AnnouncementSummary announcements = 1;
   */
  announcements: AnnouncementSummary[];
};

/**
 * Describes the message bffuser.v1.ListAnnouncementsResponse.
 * Use `create(ListAnnouncementsResponseSchema)` to create a new message.
 */
export const ListAnnouncementsResponseSchema: GenMessage<ListAnnouncementsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_announcement_service, 1);

/**
 * @generated from message bffuser.v1.GetAnnouncementRequest
 */
export type GetAnnouncementRequest = Message<"bffuser.v1.GetAnnouncementRequest"> & {
  /**
   * 告知 ID。配信側が付ける原稿ファイル名由来の値 (英数字と . _ -)。
   *
   * @generated from field: string announcement_id = 1;
   */
  announcementId: string;
};

/**
 * Describes the message bffuser.v1.GetAnnouncementRequest.
 * Use `create(GetAnnouncementRequestSchema)` to create a new message.
 */
export const GetAnnouncementRequestSchema: GenMessage<GetAnnouncementRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_announcement_service, 2);

/**
 * @generated from message bffuser.v1.GetAnnouncementResponse
 */
export type GetAnnouncementResponse = Message<"bffuser.v1.GetAnnouncementResponse"> & {
  /**
   * @generated from field: bffuser.v1.Announcement announcement = 1;
   */
  announcement?: Announcement;
};

/**
 * Describes the message bffuser.v1.GetAnnouncementResponse.
 * Use `create(GetAnnouncementResponseSchema)` to create a new message.
 */
export const GetAnnouncementResponseSchema: GenMessage<GetAnnouncementResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_announcement_service, 3);

/**
 * AnnouncementService はアプリ内「お知らせ」(リリース告知) の読み取り API。
 * 告知は全組織共通のため request に organization_id を持たず、BFF handler も
 * 組織を解決しない (認証済みセッションの存在だけを検査する)。
 *
 * @generated from service bffuser.v1.AnnouncementService
 */
export const AnnouncementService: GenService<{
  /**
   * ListAnnouncements は公開済み (配信側 index.json 掲載) の告知を
   * published_at 降順で全件返す。ページングは持たない (年数十件規模)。
   * index.json が未配信の環境では空を返す。
   *
   * @generated from rpc bffuser.v1.AnnouncementService.ListAnnouncements
   */
  listAnnouncements: {
    methodKind: "unary";
    input: typeof ListAnnouncementsRequestSchema;
    output: typeof ListAnnouncementsResponseSchema;
  },
  /**
   * GetAnnouncement は 1 件の告知本文を返す。index.json に載っていない
   * announcement_id は NotFound。
   *
   * @generated from rpc bffuser.v1.AnnouncementService.GetAnnouncement
   */
  getAnnouncement: {
    methodKind: "unary";
    input: typeof GetAnnouncementRequestSchema;
    output: typeof GetAnnouncementResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_announcement_service, 0);

